var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isApi503 || _vm.$isEnabled('maintenance-mode'))?_c('LayoutError',{attrs:{"errorPage":503}}):(_vm.isVerifyPage && _vm.isLoggedIn)?_c('RouterView'):(_vm.isLoggedIn)?_c('LayoutAuthorized'):(_vm.isGuestPage)?_c('LayoutGuest'):_c('LayoutLanding')
}
var staticRenderFns = []

export { render, staticRenderFns }